import { useLang } from "./LanguageContext";
import { EXPERTISE } from "@/data/content";
import { CONDITIONS } from "@/data/conditions";
import { EXPERTISE_I18N } from "./content_i18n";
import { CONDITIONS_HI } from "./conditions_hi";
import { CONDITIONS_MR } from "./conditions_mr";
import { CONDITIONS_GU } from "./conditions_gu";

const CONDITIONS_I18N = { hi: CONDITIONS_HI, mr: CONDITIONS_MR, gu: CONDITIONS_GU };

export const useContent = () => {
  const { lang } = useLang();
  return {
    expertise: EXPERTISE_I18N[lang] ?? EXPERTISE,
    conditions: CONDITIONS_I18N[lang] ?? CONDITIONS,
  };
};
